import React from 'react';
import AddOnCard from './AddOnCard';

type TrafficCostsPlanCardV2Props = {
  plan: {
    max_snapshots: string;
  };
  usedTrafficCostsSnapshots: number;
};
const TrafficCostsPlanCardV2 = ({ plan, usedTrafficCostsSnapshots }: TrafficCostsPlanCardV2Props) => {
  const maxSnapshots = Number.isFinite(parseInt(plan.max_snapshots)) ? parseInt(plan.max_snapshots) : 1200;
  const hasUnlimitedCredits = maxSnapshots === -1;

  return (
    <AddOnCard
      title="Traffic Costs Snapshots"
      description={`KD-TS-SNAP${hasUnlimitedCredits ? '-UNLIMITED' : ''}`}
      extensions={[
        {
          key: 'Traffic Costs Snapshots',
          value: `${usedTrafficCostsSnapshots} of ${hasUnlimitedCredits ? 'Unlimited' : maxSnapshots}`
        }
      ]}
    />
  );
};

export default TrafficCostsPlanCardV2;
